
import {finalize} from 'rxjs/operators';
import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { Dialog } from '../ui/dialog/dialog';
import { trigger, state, style, animate, transition } from '@angular/animations';

import { Record } from './record';
import { RecordService, RecordFilter } from './record.service';
import { NotifierService } from '../ui/alert/notifier.service';

import { filter as lodashFilter, size } from 'lodash';

const FILTER_KEY = 'records.search-filter';

/**
 * Dossier filter dialog
 */
@Component({
  templateUrl: './record-search-dialog.component.html',
  host: {'(window:keydown)': 'hotkeys($event)'},
  styles: [
    `.dialog-container {
      display: block;
      position: fixed;
      z-index: 300;
      width: 100%;
      left: 0;
    }`
  ],
  animations: [
    trigger(
      'openState',
      [
        state(
          'open',
          style({
            top: '0px'
          })
        ),
        state(
          'closed',
          style({
            top: '-136px'
          })
        ),
        transition('closed => open', animate('400ms ease-out')),
        transition('open => closed', animate('400ms ease-in')),
      ]
    ),
  ]
})
export class RecordSearchDialogComponent implements Dialog, OnInit {
  state = 'closed';

  search: string
  hideId: string

  lastSearch: string
  searchTimer: any

  @ViewChild('searchInput')
  searchInput: ElementRef

  records: Record[]
  selectedItem: Record
  
  onClose: () => void
  onSelect: (record: Record) => void

  constructor(
    private recordService: RecordService,
    private notifier: NotifierService,
  ) {

  }

  ngOnInit() {
    if(!this.search) {

      // Load filter from localStorage
      if(window.localStorage) {
        try {
          this.search = window.localStorage.getItem(FILTER_KEY);
        }
        catch(err) {}
      }
      
      if(!this.search) {
        this.search = '';
      }
    }

    this.lastSearch = this.search;

    this.apply();

    // Focus search input
    this.searchInput.nativeElement.focus();
  }

  close() {
    this.onClose();
  }

  select(record: Record) {
    this.onSelect(record);
  }

  apply() {
    let filter = new RecordFilter();
    filter.search = this.search;
    filter.offset = 0;
    filter.limit = 10;
    filter.order_by = 'NAME';
    filter.order_direction = 'ASC';

    this.notifier.startProgress();

    this.recordService
      .records(filter).pipe(
      finalize(() => this.notifier.endProgress()))
      .subscribe((result) => {
        if(this.hideId) {
          this.records = lodashFilter(result.records, record => {
            return record.id !== this.hideId;
          });
        }
        else {
          this.records = result.records;
        }

        if(size(this.records) > 0) {
          this.selectedItem = this.records[0];
        }
      });

    // Save filter to localStorage
    if(window.localStorage) {
      window.localStorage.setItem(FILTER_KEY, this.search);
    }
  }

  hotkeys(event: KeyboardEvent){
    
    switch(event.keyCode) {
      // Escape key
      case 27:
        this.close();
        break;
      // Enter key
      case 13:
        if(size(this.records) && this.selectedItem) {
          this.select(this.selectedItem);
        }
        event.preventDefault();
        return false;
      // Up Arrow key
      case 38:
        if(size(this.records) > 0) {
          let selectedIndex = this.records.indexOf(this.selectedItem);

          if(selectedIndex >= 0) {
            selectedIndex -= 1;

            if(selectedIndex >= 0) {
              this.selectedItem = this.records[selectedIndex];
            }
          }
        }
        break;
      // Down Arrow key
      case 40:
        if(size(this.records) > 0) {
          let selectedIndex = this.records.indexOf(this.selectedItem);

          if(selectedIndex >= 0) {
            selectedIndex += 1;

            if(selectedIndex < this.records.length) {
              this.selectedItem = this.records[selectedIndex];
            }
          }
        }
        break;
    }
  }

  searchKeyup(event: KeyboardEvent) {
    if(this.lastSearch !== this.search) {
      this.lastSearch = this.search;

      if(this.searchTimer) {
        window.clearTimeout(this.searchTimer);
      }

      this.searchTimer = window.setTimeout(() => {
        this.apply();
      }, 500);
    }
  }
}

